<template>
  <div id="group-listing" :key="groupListingKey">
    <GroupListItem 
      v-for="group in filteredGroupData"
      :key="group.id"
      :group="group"
    />
  </div>
</template>

<script>
import GroupListItem from '@/components/GroupListItem.vue'

export default {
  name: 'GroupList',
  components: {
    GroupListItem
  },
  props: {
    groupData: Array
  },
  data() {
    return {
      filteredGroupData: this.groupData,
      groupListingKey: 0
    }
  },
  methods: {
    updateData(data) {
      this.filteredGroupData = data
    }
  },
  mounted() {
    this.$root.$on('filter-search-complete', (data) => {
      this.updateData(data)
    })
  }
}
</script>

<style>
#group-listing .group-list-item:first-child {
  border-top: 1px solid #222;
}
</style>
